export default {
    // 印尼
    LOCALE_HTML: {
        'msg.language': '印尼',
        'msg.title': 'Judul',
        'msg.type': 'Kategori pertanyaan',
        'msg.des': 'Uraian pertanyaan',
        'msg.phone': 'Nomor ponsel',
        'msg.regionCode': 'Kode area',
        'msg.email': 'Kotak surat',
        'msg.choose': 'Pilih tipe',
        'msg.detail': 'Detail pesan',
        'msg.back': 'Kembali',
        'your.msg': 'Harap tinggalkan pesan',
        'msg.record': 'Catatan pesan',
        'msg.success': 'Tinggalkan pesan berhasil',
        'to.record': 'Pergi ke catatan pesan',
        completed: 'Selesai',
        submit: 'Kirimkan',
        'success.desc':
            'Pesan anda telah dikirimkan dengan sukses, terima kasih',
        'msg.form.input': 'Masukkan',
        'msg.reply': 'Membalas',
        'comment.suc': 'Terima kasih atas penilaian anda!',
        'comment.fail': 'Pengiriman gagal',
        'comment.placeholder': 'Saran untuk layanan kami dipersilakan',
        'reply.suc': 'Pengiriman berhasil',
        'reply.fail': 'Masukkan isi balasan anda',
        'reply.placeholder': 'Masukkan isi balasan anda',
        'msg.more': 'Lihat lebih banyak',
        'msg.collapse': 'Tutup',
        'msg.myservice': 'Penilaian layanan saya',
        'msg.evaluate': 'Penilaian layanan ',
        'msg.evaluateTitle': 'Penilaian layanan ',
        'msg.score': 'Skor',
        'msg.remark': 'Komentar',
        'msg.status.created': 'Telah dibuat',
        'msg.status.pending': 'Belum selesai',
        'msg.status.processing': 'Dalam proses',
        'msg.status.solved': 'Telah selesai',
        'msg.service.reply': 'Balasan layanan pelanggan',
        'msg.my.reply': 'Balasan Anda',
        'msg.toast.des': 'Uraian pertanyaan tidak ada',
        'msg.toast.type': 'Kategori pertanyaan tidak ada',
        'msg.toast.title': 'Judul tidak ada',
        'msg.toast.none': 'Tidak bisa dikosongkan',
        'msg.toast.noAnnex': 'Unggah lampiran',
        'msg.toast.noEmail': 'Kotak surat tidak bisa dikosongkan',
        'msg.toast.noTel': 'Nomor ponsel tidak bisa dikosongkan',
        'msg.toast.noRegionCode': 'Kode area tidak boleh kosong',
        'msg.toast.noZone': 'Silakan pilih zona waktu',
        'msg.toast.noDateTime': 'Silakan pilih tanggal waktu',
        'msg.toast.email': 'Masukkan kotak surat yang benar',
        'msg.toast.tel': 'Masukkan nomor ponsel yang benar',
        'msg.toast.regionCode': 'Silakan pilih kode area',
        'msg.toast.num': 'Masukkan angka yang benar',
        'msg.toast.annex': 'Unggah lampiran',
        'msg.toast.char': 'Masukkan karakter yang benar',
        'msg.list.none': 'Data ini tidak ada ',
        'msg.form.choose': 'Harap pilih',
        'msg.form.chooseZone': 'Pilih zona waktu',
        'msg.form.chooseTime': 'Pilih Waktu',
        'msg.form.chooseDate': 'Pilih Tanggal',
        'msg.form.sure': 'Konfirmasi',
        'msg.form.search': 'Mencari…',
        'msg.form.uploadError': 'Format bersalah',
        'msg.form.uploadXss':
            'Pengunggahan gagal, konten file berisi skrip ilegal',
        'msg.update.time': 'diperbarui pada',
        'msg.replace.images': 'gambar',

        MSG016: 'terselesaikan',
        MSG017: 'belum terpecahkan',
        MSG019: 'kirim',
        MSG072: 'Label evaluasi tidak boleh kosong! ',
        MSG073: 'Bahasa evaluasi tidak boleh kosong! ',
        MSG074: 'Label:',
        MSG075: 'Apakah sudah teratasi:',
        MSG076: 'Silakan pilih apakah masalahnya sudah teratasi',
        MSG015: 'Apakah tiket ini menyelesaikan masalah Anda?',

        'file.size.limit': 'Ukuran file tidak bisa melebihi dari 50MB',
        'detail.file.limit':
            '15 buah sebanyak-banyaknya, ukurannya tidak bisa melebihi dari 50M',
        'form.question.des.tip': 'Masukkan uraian pertanyaan',
        'form.title.tip': 'Masukkan judul',
        'form.class.tip': 'Pilih tipe pertanyaan',
        'upload.file': 'Unggah lampiran',
        'file.count.limit':
            'Hanya bisa unggah 15 buah lampiran sebanyak-banyaknya',
        'select.search.placeholder': 'Mencari kata kunci',
        'msg.form.sizeError1': 'Unggah lampiran yang ukurannya kurang dari 5M',
        'msg.form.sizeError2': 'Unggah lampiran yang ukurannya kurang dari 50M',
        'msg.form.submit': 'Pengiriman…',
        'msg.form.upload': 'Unggah…',
        'msg.email.tip1': 'Pesan anda tidak bisa ditemui',
        'msg.email.tip2':
            'Kalau anda meninggalkan pesan sebelumnya, bisa melewati verifikasi kotak surat untuk mencari',
        'msg.email.tip3': 'Aktifkan verifikasi kotak surat',
        'msg.email.noData': 'Data tidak ada di bawah nomor akun sekarang',
        'email.verify.tip':
            'Alamat kotak surat yang digunakan saat memasukkan pesan',
        'email.input.placeholder': 'Masukkan alamat kotak surat',
        'email.submit': 'Kirimkan i-mel',
        'email.rules.error': 'Masukkan kotak surat yang benar',
        'email.code.tip':
            'I-mel telah dikirimkan, masukkan kode verifikasi yang anda menerima',
        'email.code.placeholder': 'Masukkan kode verifikasi',
        'email.code.submit': 'Lihat sekarang',
        'email.notFind.customer': 'Informasi pelanggan tidak ditemui',
        'email.code.wrong': 'Kode verifikasi salah, masukkan lagi',
        'email.code.expired':
            'Kode verifikasi kedaluwarsa, verifikasi kotak surat lagi',
        'email.code': 'Kode verifikasi',
        'email.send.frequently': 'Operasinya terlalu sering, coba lagi nanti',
        'comment.fail.400133': 'Tiket ini telah dinilai',
        'not.get.user.info': 'Tidak dapat mendapatkan informasi Anda',
        'user.verify.tip':
            'Anda harus verifikasi sebelum Anda dapat melihat isi daftar pesan',
        'verify.type.email': 'Verifikasi surel',
        'verify.text': 'validate',
        'cancel.text': 'batalkan',
        'get.verify.code': 'Dapatkan kode verifikasi',
        'reGet.verify.code': 'Ulangi ',
        'verify.by.email.tip':
            'Kode verifikasi akan dikirim melalui email ke akun email yang Anda masukkan',
        'verify.type.phone': 'Verifikasi SMS',
        'phone.placeholder': 'Silakan masukkan nomor telepon Anda',
        'verify.by.phone.tip':
            'Kode verifikasi akan dikirim melalui SMS ke nomor telepon yang Anda masukkan',
        'phone.error': 'Silakan masukkan nomor telepon yang tepat',
        'phone.errorCode400150': 'Mengirim kode verifikasi sering',
        'phone.errorCode400233': 'Templat SMS tidak dapat kosong',
        'phone.errorCode400234': 'Kesimbangan SMS pemasaran tidak cukup',
        'phone.errorCode400235': 'Pemberitahuan keseimbangan SMS tidak cukup',
        'phone.errorCode400247': 'Galat konfigurasi SMS plugin urutan kerja',
        'phone.errorCode4400248': 'Gagal mendapatkan templat SMS',
        'phone.errorCode400249':
            'Nomor ini bukan nomor telepon pengguna yang ada',
        'phone.errorCode400250':
            'Kode verifikasi telah habis, silakan mendapatkan lagi',
        'msg.you.reply': 'Membalasmu',
        'msg.no.reply':'tidak ada balasan',
    },
    LOCALE_REQUEST: {
        400016: 'Memperoleh informasi perintah kerja telah kedaluwarsa, harap segarkan!'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'menghapus',
                cancel: 'Membatalkan',
                confirm: 'Tentu',
                inert: 'menyisipkan',
                width: 'lebar',
                height: 'tinggi'
            },
            controls: {
                clear: 'konten yang jelas',
                undo: 'menarik kembali',
                redo: 'mengulangi',
                fontSize: 'ukuran huruf',
                lineHeight: 'tinggi garis',
                letterSpacing: 'spasi kata',
                textIndent: 'indentasi paragraf',
                increaseIndent: 'meningkatkan lekukan',
                decreaseIndent: 'mengurangi indentasi',
                border: 'bingkai',
                color: 'warna',
                textColor: 'warna teks',
                backgroundColor: 'warna latar belakang',
                tempColors: 'warna sementara',
                bold: 'berani',
                italic: 'huruf miring',
                underline: 'menggarisbawahi',
                strikeThrough: 'dicoret',
                fontFamily: 'font',
                textAlign: 'perataan teks',
                alignLeft: 'kiri',
                alignCenter: 'berada di tengah',
                alignRight: 'Benar',
                alignJustify: 'kedua ujung',
                floatLeft: 'melayang ke kiri',
                floatRight: 'mengapung dengan benar',
                superScript: 'Superskrip',
                subScript: 'subskrip',
                removeStyles: 'gaya yang jelas',
                headings: 'judul',
                header: 'judul',
                normal: 'konvensional',
                orderedList: 'Daftar pesanan',
                unorderedList: 'daftar tidak terurut',
                blockQuote: 'mengutip',
                code: 'Kode',
                link: 'Tautan',
                unlink: 'tautan yang jelas',
                hr: 'garis horisontal',
                media: 'media',
                mediaLibirary: 'Perpustakaan Media',
                emoji: 'Ekspresi kecil',
                fullscreen: 'layar penuh',
                exitFullscreen: 'Keluar dari Layar Penuh'
            },
            linkEditor: {
                textInputPlaceHolder: 'masukkan teks tautan',
                linkInputPlaceHolder: 'Masukkan alamat tautan',
                inputWithEnterPlaceHolder:
                    'Masukkan alamat tautan dan tekan Enter',
                openInNewWindow: 'Buka di jendela baru',
                removeLink: 'hapus tautan'
            },
            audioPlayer: {
                title: 'memutar file audio'
            },
            videoPlayer: {
                title: 'memutar file video',
                embedTitle: 'media tertanam'
            },
            media: {
                image: 'gambar',
                video: 'video',
                audio: 'video',
                embed: 'media tertanam'
            }
        },
        finder: {
            remove: 'menghapus',
            cancel: 'Membatalkan',
            confirm: 'mengonfirmasi',
            insert: 'masukkan item yang dipilih',
            width: 'lebar',
            height: 'tinggi',
            image: 'gambar',
            video: 'video',
            audio: 'audio',
            embed: 'media tertanam',
            caption: 'Perpustakaan Media',
            dragTip: 'Klik atau seret file ke sini',
            dropTip: 'Lepaskan untuk mengunggah',
            selectAll: 'Pilih Semua',
            deselect: 'membatalkan pilihan',
            removeSelected: 'hapus item yang dipilih',
            externalInputPlaceHolder: 'Nama sumber daya|Alamat sumber daya',
            externalInputTip: `Gunakan "|" untuk memisahkan nama sumber daya dan alamat sumber daya`,
            addLocalFile: 'Tambahkan sumber daya lokal',
            addExternalSource: 'Tambahkan sumber daya web',
            unnamedItem: 'proyek tanpa judul',
            confirmInsert: 'Sisipkan item yang dipilih'
        }
    }
}
